// extracted by mini-css-extract-plugin
module.exports = {"Container":"Spinner_Container__2hy09","Loader":"Spinner_Loader__1_Lmw","load4":"Spinner_load4__1greP"};